import { action, makeObservable, observable } from 'mobx';
import { ModalState, ModalStateParams } from './ModalState';

export interface ConditionalModalStateParams extends ModalStateParams {}

export class ConditionalModalState<T> {
  readonly modal: ModalState;

  value: T | null | undefined = null;

  constructor(params?: ConditionalModalStateParams) {
    this.modal = new ModalState(params);

    makeObservable(this, {
      value: observable.ref,
      afterClose: action.bound,
      open: action.bound,
      close: action.bound,
    });
  }

  get isOpen() {
    return this.modal.isOpen;
  }

  close() {
    this.modal.close();
  }

  afterClose() {
    this.value = null;
  }

  open(value: T) {
    this.value = value;
    this.modal.open();
  }
}
